import ko from "knockout";
import $ from "jquery";
import register from "flow/knockout/register";

register.registerKnockoutBinding("slideDownVisible", {
    init: function (element, valueAccessor) {
        // Initially set the element to be instantly visible/hidden depending on the value
        const value = valueAccessor();
        $(element).toggle(ko.unwrap(value)); // Use "unwrap" so we can handle values that may or may not be observable
    },
    update: function (element, valueAccessor) {
        // Whenever the value subsequently changes, slowly fade the element in or out
        const value = valueAccessor();

        if (ko.unwrap(value)) {
            $(element).slideDown("slow");
        } else {
            $(element).slideUp();
        }
    }
});
